import { render, staticRenderFns } from "./zuiminjxwd.vue?vue&type=template&id=2183ed62&scoped=true&"
import script from "./zuiminjxwd.vue?vue&type=script&lang=js&"
export * from "./zuiminjxwd.vue?vue&type=script&lang=js&"
import style0 from "./zuiminjxwd.vue?vue&type=style&index=0&id=2183ed62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2183ed62",
  null
  
)

export default component.exports